import {render} from 'react';
import User from '@modules/User';
import Icon from '@components/common/Icon';
import ProductSearch from './components/search/ProductSearch';
import Provider from 'preact-context-provider';

const SearchProvider = ( {children} ) => {
    return (
        <Provider siteConfig={upi.conf}>
            {children}
        </Provider>
    );
}
const SearchSuggestions = {
    init () {
        const searchBoxWrapper = this.searchBoxWrapper = document.getElementById( 'search-bar-wrapper--header' );

        if ( searchBoxWrapper ) {
            const inp = searchBoxWrapper.querySelector( 'input[type="text"]' );
            searchBoxWrapper.innerHTML = '';

            render(
                <SearchProvider>
                    <ProductSearch
                        initialQuery={inp && inp.value || ''}
                        showAllSkus={User.isTamProxy()}
                        showBrandFamily={true}
                    >
                        {() =>
                            <div>
                                <div id="search-bar--header"
                                     className="flex w-full lg:flex-1 p-2 md:p-0 border-b border-solid border-grey-light md:border-none">
                                    <ProductSearch.Input placeholder="Keyword / Item#"/>
                                    <span data-action="search-bar-toggle--mobile"
                                          className="md:hidden px-2 self-center text-lg text-sky-blue">Cancel</span>
                                </div>
                                <div className="absolute w-full shadow-md bg-white">
                                    <ProductSearch.Results
                                        noResultsClass="mt-8 p-12 text-center text-xl border-t border-solid border-grey-lighter"
                                        groupLabelClass="block px-4 py-2 bg-white font-bold txt-c3 border-b border-solid border-grey-lighter"
                                    >
                                        {( results ) =>
                                            <ProductSearch.ResultsPane>
                                                <div className="absolute pin-t pin-r flex">
                                                    <a href="/resources/product-instructions"
                                                       className="flex items-center py-2 px-3 border-l border-solid border-grey-lighter">
                                                        <Icon.ui name="ifu" className="mr-1" center/>
                                                        <span className="hidden lg:block pr-1">Find a</span> Product IFU
                                                    </a>
                                                    <a href="/resources/safety-data-sheets"
                                                       className="flex items-center py-2 px-3 border-l border-solid border-grey-lighter">
                                                        <Icon.ui name="sds" className="mr-1" center/>
                                                        <span className="hidden lg:block pr-1">Find a</span> Product SDS
                                                    </a>
                                                </div>
                                                {results}
                                            </ProductSearch.ResultsPane>
                                        }
                                    </ProductSearch.Results>
                                </div>
                            </div>
                        }
                    </ProductSearch>
                </SearchProvider>,
                searchBoxWrapper
            );

        }
        else {
            console.warn( 'Could not mount <Search/> component; Root node #SearchBox not found' );
        }
    }
};

export default SearchSuggestions;


